import React, { useState } from 'react'
import Header from '../Component/Header';
import Footer from '../Component/footer';
import PageHead from '../Component/pageHead'
import { Form } from 'react-bootstrap'
import { PostAction } from '../Component/PostAction';
import { useFormik } from 'formik';

const initialformData = {
  goshala_name: '',
  contact_person: '',
  contact_number: '',
  help_type: '',
  other_information: '',
}

const HELP_TYPES = [
  { value: 'चारा', label: 'चारा' },
  { value: 'शेड', label: 'शेड' },
  { value: 'मेडिकल', label: 'मेडिकल' },
  { value: 'other', label: 'अन्य' },
]

function Help() {
  const title = 'गौ शाला मदत'
  const [formData] = useState(initialformData)
  const [visibleOther, setVisibleOther] = useState(false)
  const postUrl = '/donation/goshalaHelp'

  const { values, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: formData,
    onSubmit: (values) => {
      const callPOSTAPI = async () => {
        const res = await PostAction('post', values, postUrl)
        alert(res.message)
      }
      callPOSTAPI()
    },
  })

  const handleTypeChange = (e) => {
    const { value } = e.target
    handleChange(e)
    if (value === 'other') {
      setVisibleOther(true)
    } else {
      setVisibleOther(false)
      setFieldValue('other_information', '')
    }
  }

  return (
    <>
      <Header />
      <PageHead title={title} />
      <section className="help-page">
        <div className="container">
          <div className="help-card">
            <div className="help-card-header">
              <h2 className="help-card-title">मदत विनंती</h2>
              <p className="help-card-subtitle">
                गौशाला मदतीसाठी खालील माहिती भरा आणि सबमिट करा.
              </p>
            </div>
            <Form onSubmit={handleSubmit} className="help-form">
              <div className="row">
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label" htmlFor="goshala_name">
                    गौशाला का नाम *
                  </label>
                  <input
                    id="goshala_name"
                    className="form-control"
                    type="text"
                    name="goshala_name"
                    value={values.goshala_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label" htmlFor="contact_person">
                    संपर्क व्यक्ति *
                  </label>
                  <input
                    id="contact_person"
                    className="form-control"
                    type="text"
                    name="contact_person"
                    value={values.contact_person}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label" htmlFor="contact_number">
                    संपर्क फ़ोन *
                  </label>
                  <input
                    id="contact_number"
                    className="form-control"
                    type="tel"
                    inputMode="numeric"
                    name="contact_number"
                    value={values.contact_number}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <fieldset className="help-type-fieldset mb-3">
                <legend className="form-label help-type-legend">सहायता *</legend>
                <div className="help-type-options" role="radiogroup" aria-label="सहायता">
                  {HELP_TYPES.map((opt) => (
                    <label key={opt.value} className="help-type-option" htmlFor={`help_type_${opt.value}`}>
                      <input
                        id={`help_type_${opt.value}`}
                        className="form-check-input"
                        type="radio"
                        value={opt.value}
                        name="help_type"
                        checked={values.help_type === opt.value}
                        onChange={handleTypeChange}
                      />
                      <span>{opt.label}</span>
                    </label>
                  ))}
                </div>
              </fieldset>

              {visibleOther ? (
                <div className="mb-3">
                  <label className="form-label" htmlFor="other_information">
                    अन्य जानकारी
                  </label>
                  <textarea
                    id="other_information"
                    className="form-control"
                    rows={5}
                    name="other_information"
                    value={values.other_information}
                    onChange={handleChange}
                  />
                </div>
              ) : null}

              <div className="help-actions">
                <button className="btn help-submit-btn" type="submit">
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Help
